import { sign } from './functions.js';

/**
 * The Range defines an array of equally separated numbers.
 *
 * @param start The start-value of the Range.
 * @param stop The end-value of the Range.
 * @param step The separation between the values (default:1).
 * @returns {Array}
 */
function Range(start, stop, step) {
    if (typeof start == 'undefined' || typeof stop == 'undefined') {
        return [];
    }
    if (step && sign(stop - start) !== sign(step)) {
        throw new Error('The sign of the increment should allow to reach the stop-value.');
    }
    step = step || 1;
    start = start || 0;
    stop = stop || start;
    if ((stop - start) / step === Infinity) {
        throw new Error('Infinite range defined.');
    }
    const range = [];
    let i = -1, j;
    function rangeIntegerScale(x) {
        let curK = 1;
        while (x * curK % 1) {
            curK *= 10;
        }
        return curK;
    }
    const k = rangeIntegerScale(Math.abs(step));
    start *= k;
    stop *= k;
    step *= k;
    if (start > stop && step > 0) {
        step = -step;
    }
    if (step < 0) {
        while ((j = start + step * ++i) >= stop) {
            range.push(j / k);
        }
    }
    else {
        while ((j = start + step * ++i) <= stop) {
            range.push(j / k);
        }
    }
    return range;
}

export { Range };
